export const SMaskedInputOverrides = (error, hasEndEnhancer = false, hasLabel = false) => ({
  Root: {
    style: ({ $theme }) => ({
      borderColor: error ? $theme.colors.errorInput : '',
      backgroundColor: error ? 'transparent' : $theme.colors.white,
      paddingRight: hasEndEnhancer ? '0' : undefined,
    }),
  },
  Input: {
    style: ({ $theme, $disabled }) => ({
      color: $theme.colors.black,
      fontSize: '16px',
      paddingRight: '.75rem',
      paddingLeft: '.45rem',
      // A paddingTop key, even undefined, replaces baseui's own top padding
      ...(hasLabel ? { paddingBottom: '.125rem' } : { paddingTop: '.6875rem', paddingBottom: '.6875rem' }),
      borderColor: error ? $theme.colors.errorInput : '',
      backgroundColor: error || $disabled ? 'transparent' : $theme.colors.white,
    }),
  },
  InputContainer: {
    style: {
      paddingTop: hasLabel ? '0.625rem' : 0,
      backgroundColor: error ? 'transparent' : '',
    },
  },
  EndEnhancer: {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: hasLabel ? '0.625rem' : 0,
      paddingLeft: '4px',
      paddingRight: '8px',
      paddingBottom: '0',
      backgroundColor: error ? 'transparent' : '',
    },
  },
})
